import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=f195019a&scoped=true&"
import script from "./SectionTitle.vue?vue&type=script&lang=js&"
export * from "./SectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=f195019a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f195019a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/owldesign/Sites/snowpeak/website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f195019a')) {
      api.createRecord('f195019a', component.options)
    } else {
      api.reload('f195019a', component.options)
    }
    module.hot.accept("./SectionTitle.vue?vue&type=template&id=f195019a&scoped=true&", function () {
      api.rerender('f195019a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "development/vue-components/SectionTitle.vue"
export default component.exports